type GlobalsT = {
  userId: number | null | undefined
  hasAnalytics: boolean
}

export const Globals: GlobalsT = {
  userId: null,
  hasAnalytics: false,
}
